import React from 'react';
import {Body, Headline} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import ContentLabPlanBundle from '@/types/models/pricing/contentLabPlanBundle';
import {getPriceCurrency} from '@/views/content-studio/pricing/utils';
import Conditional from '@/components/conditional';
import styles from './PriceSection.module.scss';

type PriceProps = {
  bundle: ContentLabPlanBundle;
  currency: string;
  price: number | undefined;
  originalPrice: number | undefined;
};

function Price({
  bundle,
  currency,
  price,
  originalPrice = undefined,
}: PriceProps) {
  if (bundle === ContentLabPlanBundle.ENTERPRISE) {
    return (
      <Headline className={styles.priceSection} size="xl">
        {translate('Let’s talk')}
      </Headline>
    );
  }

  const priceCurrency = getPriceCurrency(currency, price);

  return (
    <div className={styles.price}>
      <Conditional condition={originalPrice !== undefined}>
        <Headline className={styles.discountedPrice} size="xl">
          {getPriceCurrency(currency, originalPrice)}
        </Headline>
        <div className={styles.priceGap} style={{width: '8px'}} />
      </Conditional>
      <Headline size="xl">{priceCurrency}</Headline>
      <Body size="xl" className={styles.period}>
        {translate('/per month')}
      </Body>
    </div>
  );
}

export default Price;
